import React, { useEffect, useState } from 'react';
import Icon from '@mdi/react';
import {
  dsiPackaging,
  dsiPackageCatalogue,
  dsiPlusSign,
} from '../../../../components/icons/customIcons';
import {
  Typography,
  Divider,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  InputBase,
  InputAdornment,
  SvgIcon,
} from '@material-ui/core';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { CustomizedItems } from '../../interfaces';
import handleError from '../../../../utils/handleError';
import handleNotfication from '../../../../utils/handleNotfication';
//ADDED Component
const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const useStyles = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1),
  },
  textField: {
    width: '100%',
    '&::placeholder': {
      fontWeight: '100',
    },
  },
}));

const ConfigCard = (props: {
  iconPath: string;
  title: string;
  editMode: boolean;
  data: CustomizedItems[];
  type: string;
  handleCardChanges;
  handleCustomizedItemCreation;
}) => {
  const [state, setState] = useState({});

  const [cardInputActive, setCardInputActive] = React.useState<boolean>(false);

  const [textfieldValue, setTextfieldValue] = React.useState<string>('');

  const classes = useStyles();

  const handleChange = (event, item: CustomizedItems) => {
    // setState({...state, [event.target.name]: event.target.checked});
    const { name, checked } = event.target;
    setState(prevState => ({
      ...prevState,
      [name]: checked,
    }));
    const dataToPassUp: CustomizedItems = item;
    //   {
    //   id: name,
    //   active: checked,
    //   type: props.type,
    //   name:
    // };
    dataToPassUp.active = checked;
    props.handleCardChanges(dataToPassUp);
  };

  useEffect(() => {
    // Map the props array to an object with all properties set to false
    const initialState = {};
    props.data.forEach((item: CustomizedItems) => {
      initialState[item.id] = item.active;
    });
    setState(initialState);
  }, [props.data]);

  const handleShowAddCustomizedItem = () => {
    setCardInputActive(!cardInputActive);
  };

  const textfieldOnChange = event => {
    setTextfieldValue(event.target.value);
  };

  const handleInputSubmit = () => {
    if (isPackageTypeFull()) {
      handleNotfication("محدودیت حداکثر اقلام وارد شده", "error")
      return
    }
    if (isDuplicateName(textfieldValue)) {
      handleNotfication("امکان وارد کردن اقلام با نام تکراری وجود ندارد", "error")
      return;
    }
    if (textfieldValue?.length > 0) {
      props.handleCustomizedItemCreation(textfieldValue, props.type);
      setCardInputActive(false);
      setTextfieldValue("")
    }
    else {
      handleNotfication("مقدار محتوا نمی‌تواند خالی باشد", "error");
    }
  };

  const isDuplicateName = (name: string) => {
    const oldNames = props.data.filter(el => {
      return el.customizedItemType == props.type && el.name == name
    })
    return oldNames.length > 0
  }

  const isPackageTypeFull = () => {
    const oldNames = props.data.filter(el => {
      return el.customizedItemType == props.type
    })
    return oldNames.length >= 5;
  }

  // The component will render null until the prop is passed
  if (!props.data) {
    return null;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: '200px',
        flexGrow: 1,
        border: '1px solid rgba(37, 54, 140, 0.2)',
        borderRadius: '4px',
        padding: '12px',
        columnGap: '8px',
        rowGap: '8px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Icon
          style={{
            marginRight: '-8px',
            alignSelf: 'center',
            alignContent: 'start',
          }}
          color="rgba(47, 72, 88, 1)"
          size="24px"
          path={props.iconPath}
        ></Icon>
        {props.editMode && (
          <IconButton
            style={{ padding: '0px' }}
            onClick={handleShowAddCustomizedItem}
          >
            <Icon color="rgba(47, 72, 88, 1)" size="24px" path={dsiPlusSign} />
          </IconButton>
        )}
      </div>

      {cardInputActive && props.editMode && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <TextField
            style={{
              display: 'flex',
              flex: 1,
              flexShrink: 1,
            }}
            size="small"
            variant="outlined"
            required={false}
            placeholder={`نام محتوا را وارد کنید`}
            value={textfieldValue}
            onChange={textfieldOnChange}
            className={classes.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {props.editMode && (
                    <IconButton
                      style={{ padding: '0px' }}
                      onClick={handleInputSubmit}
                    >
                      <SvgIcon viewBox="0 -6 24 24" style={{}}>
                        <path d={dsiPlusSign} />
                      </SvgIcon>

                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
          {/*
          <TextField
            variant="outlined"
            size="small"
            value={textfieldValue}
            onChange={textfieldOnChange}
            fullWidth
          />
          <Button
            style={{maxWidth: '2px'}}
            variant="contained"
            color="primary"
            onClick={handleInputSubmit}
          >
            <Typography style={{fontWeight: '400', fontSize: '12px'}}>
              افزودن
            </Typography>
          </Button>
          */}
        </div>
      )}

      <Typography
        style={{
          fontSize: '13px',
          fontWeight: '700',
          color: 'rgba(47, 72, 88, 1)',
        }}
      >
        {props.title}
      </Typography>
      <Divider />
      {props.data.map((customizedItem: CustomizedItems) => (
        customizedItem.customizedItemType === props.type &&
        !props.editMode &&
        customizedItem.active === true && (
          <Typography
            key={customizedItem.id}
            style={{
              fontSize: '11px',
              fontWeight: '400',
              color: 'rgba(47, 72, 88, 1)',
            }}
          >
            {customizedItem.name}
          </Typography>
        )
      ))}
      {props.editMode &&
        props.data.map((customizedItem: CustomizedItems) => {
          if (customizedItem.customizedItemType === props.type) {
            return (
              <FormControlLabel
                key={customizedItem.id}
                control={
                  <Checkbox
                    onChange={event => {
                      handleChange(event, customizedItem);
                    }}
                    checked={state[customizedItem.id] || false}
                    name={customizedItem.id.toString()}
                    color="primary"
                    size="small"
                  />
                }
                label={
                  <Typography
                    style={{
                      fontSize: '11px',
                      fontWeight: '400',
                      color: 'rgba(47, 72, 88, 1)',
                    }}
                  >
                    {customizedItem.name}
                  </Typography>
                }
              />
            );
          } else {
            return null;
          }
        })}
    </div>
  );
};

export default ConfigCard;
